export enum headerEvents {
    HIDE_CREATE_MENU = 'header/hideCreateMenu',
    NOTIFY_HEADER_MINIMIZED_STATE = 'header/minimized',
}

const hideCreateMenu = function () {
    const event = new CustomEvent(headerEvents.HIDE_CREATE_MENU);
    window.dispatchEvent(event);
};

const notifyHeaderMinimized = function (state: boolean) {
    const event = new CustomEvent(headerEvents.NOTIFY_HEADER_MINIMIZED_STATE, {
        detail: state,
    });
    window.dispatchEvent(event);
};

export default {
    headerEvents,
    hideCreateMenu,
    notifyHeaderMinimized,
};
